import React from 'react'
import {Route, Switch, withRouter, Redirect} from 'react-router-dom'
import AccountOverview from '../Common/AccountOverview'

const BinaryRoutes = ({match: {path}}) => (
  <Switch>
    <Redirect exact from={`${path}/transactions`} to="/transactions/:accountId/deposit"/>
    <Route path={`${path}/:parentPath/:childPath+`} render={({match}) => <Redirect to={`${path}/${match.params.parentPath}`} />} />
    <Route path={`${path}`} component={AccountOverview} />
  </Switch>
)

export default withRouter(BinaryRoutes)
